import React from 'react';
import { Card } from './ui/card';
import { Star } from 'lucide-react';

const TestimonialsNew = () => {
  const testimonials = [
    {
      name: 'Dennis Sim',
      role: 'Marketing Guru',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/2c6igpo0_tmp2lpda91q.webp',
      text: "I want to thank Steven for his incredible insight and expertise. I never realized how much my signature was holding me back until he analyzed it and explained its impact on my energy and success. After making the adjustments he suggested, I began to experience better opportunities, improved self-confidence, and even a stronger sense of financial stability. I highly recommend Steven's Signature of Wealth program to anyone looking for real transformation!"
    },
    {
      name: 'Aaron Chong',
      role: 'Ultimate Sales',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/zrg31bzy_tmpc31uzexj.webp',
      text: "Steven has a unique skill that goes beyond just redesigning a signature—he transforms lives. After working with him, I noticed a shift in my confidence, decision-making, and even my financial opportunities. My new signature not only looks more powerful but also carries a strong, positive energy that aligns with my personal and professional growth. If you're looking to improve your life in ways you never imagined, start with your signature!"
    },
    {
      name: 'KT Goo',
      role: 'Wealth Strategist',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/zhwhrhbp_tmpcy7vko_x.webp',
      text: "Steven is amazing! He knew exactly what was wrong. He pointed out how my strokes were limiting my energy and blocking my financial flow. That moment changed everything. I followed his advice, redesigned my signature, and within months, I noticed a significant shift in my career and personal life. Steven's ability to read and enhance a signature is truly remarkable. This is more than just a signature change—it's a life upgrade!"
    }
  ];

  return (
    <div className="py-24 bg-[#111113]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase mb-4">
            Authentic Insights. Measurable Impact.
          </p>
          <h2 className="text-5xl font-bold text-white mb-6">
            They didn't just <span className="italic text-[#F5A623]">learn something new.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            They changed how they approach decisions, timing, and opportunities — and their results.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index}
              className="bg-[#1A1A1D] border-white/10 p-6 hover:border-[#F5A623]/50 transition-all duration-300"
            >
              <div className="mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-auto object-contain mx-auto rounded-xl border-4 border-[#F5A623]"
                />
              </div>
              <div className="flex justify-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#F5A623] text-[#F5A623]" />
                ))}
              </div>
              <p className="text-gray-300 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-white/10 pt-4">
                <p className="text-white font-bold">{testimonial.name}</p>
                <p className="text-[#F5A623] text-sm">{testimonial.role}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsNew;